import InstantTrialSuccess from "../components/InstantTrialSuccess/InstantTrialSuccess";

const InstantTrialConfirmationPage = () => {
  return <InstantTrialSuccess />;
};

export default InstantTrialConfirmationPage;
